import React, { useEffect, useState } from "react";
import { object, bool } from "prop-types";

import RankingTableWidget from "../RankingTableWidget";
import { fetchBSchoolsData, fetchEntityData } from "../../utils/entity-data";

const Listing500India = ({ collection, storyPage = false, story = {} }) => {
  const entityData = storyPage ? collection : collection.entityData;
  const [entityDetails, setEntityDetails] = useState([]);

  const { name, year, description, buttonText, href, colHeadlines, yearId, slug } = entityData;

  const logoName = {
    "next500-snapshot-year": "/images/logos/next-500.png",
    "bestbschools-snapshot-year": "/images/logos/best-b-schools.png",
    "fortune500-snapshot-year": "/images/logos/fortune-500.png",
    "emergingcompanies-snapshot-year": "/images/logos/the-emerging-companies.png",
  };

  useEffect(() => {
    const fetchData = async () => {
      const data =
        slug === "bestbschools-snapshot-year" ? await fetchBSchoolsData(year, 5) : await fetchEntityData(slug, yearId);
      setEntityDetails(data);
    };

    fetchData();
  }, [slug, yearId]);

  if (!entityDetails.length) return null;

  return (
    <RankingTableWidget
      headline={name}
      year={year}
      subHeadline={description}
      buttonText={buttonText}
      logoLink={logoName[entityData.slug]}
      href={href}
      tHeadData={colHeadlines}
      tBodyData={entityDetails}
      customClassName={slug === "bestbschools-snapshot-year" ? "best-b-schools" : ""}
      storyPage={storyPage}
      story={story}
    />
  );
};

Listing500India.defaultProps = {
  collection: {},
};

Listing500India.propTypes = {
  collection: object,
  storyPage: bool,
};

export default Listing500India;
